/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AuditTrailViewIEnumerableResponse } from '../models';
import { BankRequest } from '../models';
import { BankViewIEnumerableResponse } from '../models';
import { BankViewResponse } from '../models';
import { BooleanResponse } from '../models';
import { InvestigationTypeRequest } from '../models';
import { InvestigationTypeViewIEnumerableResponse } from '../models';
import { InvestigationTypeViewResponse } from '../models';
import { Request } from '../models';
/**
 * ConfigTrustApi - axios parameter creator
 * @export
 */
export const ConfigTrustApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Bank Audit Trails
         * @param {number} bankId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetBankAuditTrailsBankIdGet: async (bankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankId' is not null or undefined
            if (bankId === null || bankId === undefined) {
                throw new RequiredError('bankId','Required parameter bankId was null or undefined when calling apiV2ConfigTrustGetBankAuditTrailsBankIdGet.');
            }
            const localVarPath = `/api/v2/ConfigTrust/GetBankAuditTrails/{bankId}`
                .replace(`{${"bankId"}}`, encodeURIComponent(String(bankId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory
         * @param {number} bankId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetBankByIdBankIdGet: async (bankId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bankId' is not null or undefined
            if (bankId === null || bankId === undefined) {
                throw new RequiredError('bankId','Required parameter bankId was null or undefined when calling apiV2ConfigTrustGetBankByIdBankIdGet.');
            }
            const localVarPath = `/api/v2/ConfigTrust/GetBankById/{bankId}`
                .replace(`{${"bankId"}}`, encodeURIComponent(String(bankId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Banks
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetBanksPost: async (body?: Request, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ConfigTrust/GetBanks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Type Audit Trails
         * @param {number} investigationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet: async (investigationTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationTypeId' is not null or undefined
            if (investigationTypeId === null || investigationTypeId === undefined) {
                throw new RequiredError('investigationTypeId','Required parameter investigationTypeId was null or undefined when calling apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet.');
            }
            const localVarPath = `/api/v2/ConfigTrust/GetInvestigationTypeAuditTrails/{investigationTypeId}`
                .replace(`{${"investigationTypeId"}}`, encodeURIComponent(String(investigationTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Type
         * @param {number} investigationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet: async (investigationTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationTypeId' is not null or undefined
            if (investigationTypeId === null || investigationTypeId === undefined) {
                throw new RequiredError('investigationTypeId','Required parameter investigationTypeId was null or undefined when calling apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet.');
            }
            const localVarPath = `/api/v2/ConfigTrust/GetInvestigationTypeById/{investigationTypeId}`
                .replace(`{${"investigationTypeId"}}`, encodeURIComponent(String(investigationTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Types
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetInvestigationTypesPost: async (body?: Request, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ConfigTrust/GetInvestigationTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Save Signatory
         * @param {BankRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustSaveBankPost: async (body?: BankRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ConfigTrust/SaveBank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Save Investigation Type
         * @param {InvestigationTypeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustSaveInvestigationTypePost: async (body?: InvestigationTypeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/ConfigTrust/SaveInvestigationType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigTrustApi - functional programming interface
 * @export
 */
export const ConfigTrustApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Returns Bank Audit Trails
         * @param {number} bankId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustGetBankAuditTrailsBankIdGet(bankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditTrailViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustGetBankAuditTrailsBankIdGet(bankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory
         * @param {number} bankId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustGetBankByIdBankIdGet(bankId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankViewResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustGetBankByIdBankIdGet(bankId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Banks
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustGetBanksPost(body?: Request, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustGetBanksPost(body, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Type Audit Trails
         * @param {number} investigationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet(investigationTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditTrailViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet(investigationTypeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Type
         * @param {number} investigationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet(investigationTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationTypeViewResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet(investigationTypeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Investigation Types
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustGetInvestigationTypesPost(body?: Request, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestigationTypeViewIEnumerableResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustGetInvestigationTypesPost(body, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Save Signatory
         * @param {BankRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustSaveBankPost(body?: BankRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustSaveBankPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Save Investigation Type
         * @param {InvestigationTypeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2ConfigTrustSaveInvestigationTypePost(body?: InvestigationTypeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await ConfigTrustApiAxiosParamCreator(configuration).apiV2ConfigTrustSaveInvestigationTypePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ConfigTrustApi - factory interface
 * @export
 */
export const ConfigTrustApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Returns Bank Audit Trails
         * @param {number} bankId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetBankAuditTrailsBankIdGet(bankId: number, options?: any): AxiosPromise<AuditTrailViewIEnumerableResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustGetBankAuditTrailsBankIdGet(bankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Signatory
         * @param {number} bankId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetBankByIdBankIdGet(bankId: number, options?: any): AxiosPromise<BankViewResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustGetBankByIdBankIdGet(bankId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Banks
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetBanksPost(body?: Request, showActiveOnly?: boolean, options?: any): AxiosPromise<BankViewIEnumerableResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustGetBanksPost(body, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation Type Audit Trails
         * @param {number} investigationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet(investigationTypeId: number, options?: any): AxiosPromise<AuditTrailViewIEnumerableResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet(investigationTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation Type
         * @param {number} investigationTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet(investigationTypeId: number, options?: any): AxiosPromise<InvestigationTypeViewResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet(investigationTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Investigation Types
         * @param {Request} [body] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustGetInvestigationTypesPost(body?: Request, showActiveOnly?: boolean, options?: any): AxiosPromise<InvestigationTypeViewIEnumerableResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustGetInvestigationTypesPost(body, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Save Signatory
         * @param {BankRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustSaveBankPost(body?: BankRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustSaveBankPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Save Investigation Type
         * @param {InvestigationTypeRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2ConfigTrustSaveInvestigationTypePost(body?: InvestigationTypeRequest, options?: any): AxiosPromise<BooleanResponse> {
            return ConfigTrustApiFp(configuration).apiV2ConfigTrustSaveInvestigationTypePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigTrustApi - object-oriented interface
 * @export
 * @class ConfigTrustApi
 * @extends {BaseAPI}
 */
export class ConfigTrustApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Returns Bank Audit Trails
     * @param {number} bankId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustGetBankAuditTrailsBankIdGet(bankId: number, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustGetBankAuditTrailsBankIdGet(bankId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Signatory
     * @param {number} bankId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustGetBankByIdBankIdGet(bankId: number, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustGetBankByIdBankIdGet(bankId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Banks
     * @param {Request} [body] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustGetBanksPost(body?: Request, showActiveOnly?: boolean, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustGetBanksPost(body, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation Type Audit Trails
     * @param {number} investigationTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet(investigationTypeId: number, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustGetInvestigationTypeAuditTrailsInvestigationTypeIdGet(investigationTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation Type
     * @param {number} investigationTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet(investigationTypeId: number, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustGetInvestigationTypeByIdInvestigationTypeIdGet(investigationTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Investigation Types
     * @param {Request} [body] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustGetInvestigationTypesPost(body?: Request, showActiveOnly?: boolean, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustGetInvestigationTypesPost(body, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Save Signatory
     * @param {BankRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustSaveBankPost(body?: BankRequest, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustSaveBankPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Save Investigation Type
     * @param {InvestigationTypeRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigTrustApi
     */
    public apiV2ConfigTrustSaveInvestigationTypePost(body?: InvestigationTypeRequest, options?: any) {
        return ConfigTrustApiFp(this.configuration).apiV2ConfigTrustSaveInvestigationTypePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
